import { Logger } from '../lib/Logger';
const LocalStorageNotAvailable = 'Local storage is not available or access to local storage is denied for the current document. It may affect the proper work of the SDK.';
export function createStorage(key) {
    return {
        get() {
            try {
                const value = window.localStorage.getItem(key);
                return value ? JSON.parse(value) : null;
            }
            catch (_a) {
                Logger.warn(LocalStorageNotAvailable);
                return null;
            }
        },
        set(data) {
            try {
                const json = JSON.stringify(data);
                window.localStorage.setItem(key, json);
            }
            catch (_a) {
                Logger.warn(LocalStorageNotAvailable);
            }
        },
        remove() {
            try {
                window.localStorage.removeItem(key);
            }
            catch (_a) {
                Logger.warn(LocalStorageNotAvailable);
            }
        },
    };
}
//# sourceMappingURL=storage.js.map